import { useTheme } from '@mui/material';

export const getStatusColor = (status?: string) => {
  // eslint-disable-next-line
  const theme = useTheme();
  // TODO: theme doesn't work here????
  // need to figure out
  theme.palette.primary.main = '#163B3F';
  theme.palette.secondary.main = '#76B041';
  switch (status) {
    case 'ontrack':
      return [
        theme.palette.secondary.main,
        `${theme.palette.secondary.main}1f`,
      ];
    case 'complete':
      return [theme.palette.primary.main, `${theme.palette.primary.main}1f`];
    case 'warning':
      return [theme.palette.warning.main, `${theme.palette.warning.main}1f`];
    case 'pastdue':
      return [theme.palette.error.main, `${theme.palette.error.main}1f`];
    default:
      return [theme.palette.text.secondary, theme.palette.common.white];
  }
};
